import { render } from "./ForgotPage.vue?vue&type=template&id=39374ee5"
import script from "./ForgotPage.vue?vue&type=script&lang=js"
export * from "./ForgotPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__